import React from 'react';
import classNames from 'classnames';
import capitalize from 'lodash.capitalize';
import styled from 'styled-components';

interface TextLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    color?: 'default' | 'primary' | 'secondary' | 'danger';
}

const StyledAnchor = styled.a`
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 0.34px;
    line-height: 24px;
    cursor: pointer;

    &.textLinkDefault {
        color: #1884eb;
        &:hover {
            color: #42a5f5;
        }
        &:focus {
            color: #0071d4;
            outline: none;
        }
        &[disabled] {
            color: rgba(24, 132, 235, 0.3);
        }
    }
    &.textLinkPrimary {
        color: #00aa55;
        &:hover {
            color: #26bc71;
        }
        &:focus {
            color: #00934a;
            outline: none;
        }
        &[disabled] {
            color: rgba(0, 170, 85, 0.3);
        }
    }
    &.textLinkSecondary {
        color: #000000;
        &:hover {
            color: rgba(0, 0, 0, 0.87);
        }
        &:focus {
            color: #111111;
            outline: none;
        }
        &[disabled] {
            color: rgba(0, 0, 0, 0.3);
        }
    }
    &.textLinkDanger {
        color: #df352c;
        &:hover {
            color: #fb3e34;
        }
        &:focus {
            color: #d4271d;
            outline: none;
        }
        &[disabled] {
            color: #df352c;
        }
    }
`;

const TextLink: React.FC<TextLinkProps> = ({
    color = 'default',
    children,
    className,
    ...others
}: TextLinkProps) => {
    return (
        <StyledAnchor
            {...others}
            className={classNames(`textLink${capitalize(color)}`, className)}
        >
            {children}
        </StyledAnchor>
    );
};
export default TextLink;
